<template>
    <Card is-round mode="default" is-dark class="uk-card-hover">
        <div class="uk-text-center">
            <img
                v-if="clickAndBuy.mediaFileId"
                :src="
                    apiUrl +
                    '/clickandbuys/' +
                    clickAndBuy.id +
                    '/media/' +
                    clickAndBuy.mediaFileId
                "
                class="clickandbuy-media"
                :alt="clickAndBuy.mediaFileId" />
        </div>

        <div class="clickandbuy-price uk-badge badge">
            {{ getPrice() }}
        </div>

        <div class="clickandbuy-title">
            {{ clickAndBuy.title }}
        </div>

        <div
            v-if="clickAndBuy.text"
            class="clickandbuy-text"
            v-html="
                clickAndBuy.text.length > 440
                    ? clickAndBuy.text.slice(0, 437) + '...'
                    : clickAndBuy.text
            " />

        <div class="uk-margin-medium-top" />

        <span v-on:click="selected()">
            <LinkObject
                :to="computedGetClickAndBuyRootLink + '/' + clickAndBuy.id">
                <Button mode="success" is-round is-max is-large>
                    <Translate
                        v-if="isWithPriceVariable"
                        translation-key="more.information" />
                    <Translate
                        v-else-if="isWithPrice"
                        translation-key="to.offer" />
                    <Translate v-else translation-key="Select" />
                </Button>
            </LinkObject>
        </span>
    </Card>
</template>

<script>
import Card from '@/components/generic/Card.vue';
import Button from '@/components/generic/Button.vue';
import Translate from '@/components/Translate.vue';
import LinkObject from '@/components/LinkObject.vue';

export default {
    name: 'ClickAndBuyElement',
    components: {LinkObject, Translate, Button, Card},
    props: {
        clickAndBuy: {
            id: String,
            title: String,
            text: String,
            mediaFileId: String,
            price: Number,
        },
    },
    methods: {
        selected() {
            this.$store.state.clickandbuyfollow = true;
        },
        getPrice() {
            if (this.clickAndBuy.price && this.clickAndBuy.price > 0.0) {
                return this.getNumberWithCurrency(this.clickAndBuy.price);
            }

            return this.$t('free');
        },
    },
    computed: {
        isWithPriceVariable() {
            return (
                this.clickAndBuy &&
                this.clickAndBuy.isPriceVariable &&
                this.clickAndBuy.isPriceVariable > 0.0
            );
        },
        isWithPrice() {
            return (
                this.clickAndBuy &&
                this.clickAndBuy.price &&
                this.clickAndBuy.price > 0.0
            );
        },
    },
};
</script>

<style lang="scss" scoped>
.clickandbuy-media {
    border-radius: 5px;
    max-height: 200px;
}

.clickandbuy-title {
    font-size: 18px;
    font-weight: 500;
    margin-top: 20px;
}

.clickandbuy-text {
    word-break: break-word;
    margin-top: 15px;
    font-weight: 100;
}

.clickandbuy-price {
    margin-top: 20px;
}

.badge {
    font-size: 16px !important;
    padding: 12px 15px !important;
    background-color: $info-color !important;
}
</style>
